import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import React from 'react'
import { useConnect } from 'wagmi'

import useActiveWeb3React from '../../wagmi/hooks/useActiveWeb3React'
import { useAutoConnect } from '../../wagmi/hooks/useAutoConnect'
import { AppearOnMount } from '../Animation'
import { Button as UIButton, ButtonProps } from '../Button'
import { Loader } from '../Loader'
import { ConnectButton } from './Connect'



export type Props<C extends React.ElementType> = ButtonProps<C> & {
  // TODO ramin: remove param when wagmi adds onConnecting callback to useAccount
  hack?: ReturnType<typeof useConnect>
  supportedNetworks?: ChainId[]
  appearOnMount?: boolean
}

export const Button = <C extends React.ElementType>({
  hack,
  children,
  supportedNetworks,
  appearOnMount = true,
  ...rest
}: Props<C>) => {
  // TODO ramin: remove param when wagmi adds onConnecting callback to useAccount
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pendingConnection, isReconnecting, isConnected, isConnecting } = useActiveWeb3React()

  useAutoConnect()


  
  if (isConnecting && appearOnMount) {
    return (
      <UIButton
        className={rest.fullWidth ? 'w-full !opacity-100' : '!opacity-100'}
        size="md"
        color="gray"
        variant="filled"
        rounded="none"
        disabled
        {...rest}
      >
        Connecting
        <Loader.Dots />
      </UIButton>
    )
  }

  return (
    <AppearOnMount enabled={appearOnMount}>
      {(isMounted: any) => {
        // Pending confirmation state
        // Awaiting wallet confirmation
        if (pendingConnection) {
          return (
            <UIButton
              className={rest.fullWidth ? 'w-full !opacity-100' : '!opacity-100'}
              size="md"
              color="gray"
              variant="filled"
              rounded="none"
              disabled
              {...rest}
            >
              Authorize Wallet
              <Loader.Dots />
            </UIButton>
          )
        }

        // Disconnected state
        // We are mounted on the client, but we're not connected, and we're not reconnecting (address is not available)
        if (!isConnected && !isReconnecting && isMounted) {
          return <ConnectButton {...rest}>{children}</ConnectButton>
        }

        return (
          <UIButton size="md" color="gray" variant="filled" rounded="none" {...rest}>
            {children || 'Connect Wallet'}
          </UIButton>
        )
      }}
    </AppearOnMount>
  )
}
